import React, { useEffect } from "react";
import $ from "jquery";
import "../../assets/styles/dashboardItems.css";

const Graph = () => {
  function sliceSize(dataNum, dataTotal) {
    return (dataNum / dataTotal) * 360;
  }
  function addSlice(sliceSize, pieElement, offset, sliceID, color) {
    $(pieElement).append(
      "<div class='slice " + sliceID + "'><span></span></div>"
    );
    var offset = offset - 1;
    var sizeRotation = -179 + sliceSize;
    $("." + sliceID).css({
      transform: "rotate(" + offset + "deg) translate3d(0,0,0)",
    });
    $("." + sliceID + " span").css({
      transform: "rotate(" + sizeRotation + "deg) translate3d(0,0,0)",
      "background-color": color,
    });
  }
  function iterateSlices(
    sliceSize,
    pieElement,
    offset,
    dataCount,
    sliceCount,
    color
  ) {
    var sliceID = "s" + dataCount + "-" + sliceCount;
    var maxSize = 179;
    if (sliceSize <= maxSize) {
      addSlice(sliceSize, pieElement, offset, sliceID, color);
    } else {
      addSlice(maxSize, pieElement, offset, sliceID, color);
      iterateSlices(
        sliceSize - maxSize,
        pieElement,
        offset + maxSize,
        dataCount,
        sliceCount + 1,
        color
      );
    }
  }
  function createPie(dataElement, pieElement) {
    var listData = [];
    $(dataElement + " span").each(function () {
      listData.push(Number($(this).html()));
    });
    var listTotal = 0;
    for (var i = 0; i < listData.length; i++) {
      listTotal += listData[i];
    }
    var offset = 0;
    var color = ["#004996", "#60A92C", "#DEFFC6", "#C6E2FF"];
    for (var i = 0; i < listData.length; i++) {
      var size = sliceSize(listData[i], listTotal);
      iterateSlices(size, pieElement, offset, i, 0, color[i]);
      $(dataElement + " li:nth-child(" + (i + 1) + ")").css(
        "border-color",
        color[i]
      );
      offset += size;
    }
  }

  useEffect(() => {
    // Clear any existing slices before creating new ones
    $(".pieID.pie").empty();
    createPie(".pieID.legend", ".pieID.pie");
  }, []);

  return (
    <>
      <div className="graphChart">
        <main>
          <h1>Number of Users</h1>
          <section>
            <div class="pieID pie"></div>
            <ul class="pieID legend">
              <li>
                <em>User Admin</em>
                <span>78</span>
              </li>
              <li>
                <em>Users in Sales</em>
                <span>45</span>
              </li>
              <li>
                <em>User Admin</em>
                <span>27</span>
              </li>
              <li>
                <em>User Admin</em>
                <span>15</span>
              </li>
            </ul>
          </section>

          <div className="totalContainer">
            <div>288</div>
            <div className="total">Total Applicants</div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Graph;
